/**
 * Market Collection Override
 * 
 * When a non-default market has a shadow collection configured via
 * collection.metafields.market_collection[market_handle], this script:
 * 
 * 1. Patches window.fetch to redirect filter/sort/pagination AJAX requests
 *    from the original collection URL to the shadow collection URL
 * 2. Silently corrects the filter sidebar (which was SSR'd from the URL 
 *    collection) by fetching the correct filters from the shadow collection
 */
(function() {
  'use strict';

  var section = document.querySelector('[data-shadow-collection-path]');
  if (!section) return;

  var shadowPath = section.dataset.shadowCollectionPath;
  var originalPath = section.dataset.originalCollectionPath;
  if (!shadowPath || !originalPath) return;

  // Normalize paths: remove trailing slashes for consistent matching
  shadowPath = shadowPath.replace(/\/+$/, '');
  originalPath = originalPath.replace(/\/+$/, '');

  // Helper to safely match strictly as a path, avoiding accidental rewrites of 
  // third-party APIS (e.g., https://analytics.com/track?ref=/collections/bestseller)
  var escapeRegExp = function(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };
  var pathRegex = new RegExp('^(https?:\\/\\/[^\\/]+)?' + escapeRegExp(originalPath) + '([\\/?#]|$)');

  var rewriteUrlIfMatches = function(urlStr) {
    if (typeof urlStr !== 'string') return urlStr;
    if (pathRegex.test(urlStr)) {
      return urlStr.replace(originalPath, shadowPath);
    }
    return urlStr;
  };

  // === 1. Patch fetch API ===
  // Intercepts AJAX requests from more-loader.liquid
  var originalFetch = window.fetch;
  window.fetch = function(input, init) {
    if (typeof input === 'string') {
      input = rewriteUrlIfMatches(input);
    } else if (input instanceof Request) {
      var newUrl = rewriteUrlIfMatches(input.url);
      if (newUrl !== input.url) {
        input = new Request(newUrl, input);
      }
    }
    return originalFetch.call(this, input, init).then(function(res) {
      // Create a cloned response to process its text, since body can only be read once
      var contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('text/html') !== -1) {
        return res.text().then(function(text) {
          // Replace any generated shadow collection URLs back to original URLs
          // so that filter-remove links and pagination links appear normal
          var newText = text.split(shadowPath).join(originalPath);
          return new Response(newText, {
            status: res.status,
            statusText: res.statusText,
            headers: res.headers
          });
        });
      }
      return res;
    });
  };

  // === 2. Patch XMLHttpRequest (in case any code uses it) ===
  var originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    url = rewriteUrlIfMatches(url);
    return originalXHROpen.apply(this, [method, url].concat(Array.prototype.slice.call(arguments, 2)));
  };

  // === 3. Silently correct filter sidebar ===
  // SSR renders filters from the URL collection (approximate). 
  // We fetch the correct filters from the shadow collection in the background.
  // Reuse the shared section-id lookup from collection-filters.js (guarded in
  // case this script loads first)
  var sectionId = (typeof erjGetFiltersSectionId === 'function')
    ? erjGetFiltersSectionId()
    : null;

  if (sectionId) {
    var searchParams = window.location.search;
    var fetchUrl = shadowPath + searchParams + (searchParams ? '&' : '?') + 'section_id=' + sectionId;

    // Rewrite non-USD price params for the request only.
    if (typeof erjRewritePriceParamsForRequest === 'function') {
      fetchUrl = erjRewritePriceParamsForRequest(fetchUrl);
    }

    originalFetch(fetchUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        // Run identical shadow path reversion for SSR sync
        var newHtml = html.split(shadowPath).join(originalPath);
        var doc = new DOMParser().parseFromString(newHtml, 'text/html');

        // Refine the rounded USD tiers before inserting any fetched products.
        if (typeof erjFilterProductCardsByPriceRange === 'function') {
          erjFilterProductCardsByPriceRange(doc, originalPath + searchParams);
        }

        // Replace v2 filter sidebar
        var newV2Filters = doc.querySelector('.erj-collection-filter-panel-inner');
        var curV2Filters = document.querySelector('.erj-collection-filter-panel-inner');
        if (newV2Filters && curV2Filters) {
          curV2Filters.innerHTML = newV2Filters.innerHTML;
          if (typeof _erjCollectionInit === 'function') _erjCollectionInit();
        }

        // Replace product count
        var newCount = doc.getElementById('ProductCount');
        var curCount = document.getElementById('ProductCount');
        if (newCount && curCount) {
          curCount.innerHTML = newCount.innerHTML;
        }
        var newCountDesktop = doc.getElementById('ProductCountDesktop');
        var curCountDesktop = document.getElementById('ProductCountDesktop');
        if (newCountDesktop && curCountDesktop) {
          curCountDesktop.innerHTML = newCountDesktop.innerHTML;
        }

        // Critical: Update the entire product grid on initial load if URL has filters!
        // SSR cannot filter metafield collections directly, so we must rely on this AJAX patch.
        if (searchParams) {
          var newGrid = doc.getElementById('ProductGridContainer');
          var curGrid = document.getElementById('ProductGridContainer');
          if (newGrid && curGrid) {
            curGrid.innerHTML = newGrid.innerHTML;
            
            if (typeof window._erj_ !== 'undefined' && typeof window._erj_.initPromoSlotsPopup === 'function') {
              window._erj_.initPromoSlotsPopup();
            }

            if (typeof setLoadMore === 'function') setLoadMore();
            if (typeof runAsyncActions === 'function') runAsyncActions();
            if (typeof initVariantPickersInNewItems === 'function') initVariantPickersInNewItems();
          }

          var newV2Grid = doc.querySelector('.erj-collection-wrapper');
          var curV2Grid = document.querySelector('.erj-collection-wrapper');
          if (newV2Grid && curV2Grid) {
            var curTitleEl = curV2Grid.querySelector('.erj-collection-title');
            var curTitleHtml = curTitleEl ? curTitleEl.innerHTML : null;

            curV2Grid.innerHTML = newV2Grid.innerHTML;

            if (curTitleHtml) {
               var replacedTitleEl = curV2Grid.querySelector('.erj-collection-title');
               if (replacedTitleEl) replacedTitleEl.innerHTML = curTitleHtml;
            }

            if (typeof window._erj_ !== 'undefined' && typeof window._erj_.initPromoSlotsPopup === 'function') {
              window._erj_.initPromoSlotsPopup();
            }

            if (typeof _erjCollectionInit === 'function') _erjCollectionInit();
            if (typeof runAsyncActions === 'function') runAsyncActions();
            if (typeof setLoadMore === 'function') setLoadMore();
            if (typeof initVariantPickersInNewItems === 'function') initVariantPickersInNewItems();
          }
        }
      })
      .catch(function(err) {
        console.warn('[Market Override] Filter correction failed:', err);
      });
  }
})();
